<template>
  <div class="personal-logo">
    <div id="head">
      <div class="logo">
        <div id="logo_left">
          <div class="left">
            <img
            :src="imgUrl"
            @click="doTips"
          >
          </div>
          <div class="right">
            <div class="system_name">{{systemName}}—<span>个人中心</span></div>
            <div class="enterprise-name">({{enterpriseName}})</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["configData"],
  data() {
    return {
      searchTitle: "",
      name: "",
      headUrl: "",
      unreadMessage: 0,
      // userShow: false
    };
  },
  computed: {
    imgUrl() {
      return this.$store.state.imgUrl
    },
    enterpriseName() {
      return this.$store.state.enterpriseName
    },
    systemName() {
      return this.$store.state.systemName
    }
  },
  created() {
    // this.userShow = sessionStorage.token?true:false
  //   this.name = sessionStorage.account;
  //   this.$ajax
  //     .post(
  //       "/comuser-service/Account/seeAccount",
  //       this.postData({
  //         id: sessionStorage.userUuid
  //       })
  //     )
  //     .then(res => {
  //       this.headUrl = res.data.tbUser.photoUrl;
  //       if (this.headUrl === '"null"') {
  //         this.headUrl = ''
  //       }
  //     });
  //   this.getUnreadMessage()
  //   this.getReadMessage()
  },
  // mounted () {
  //   this.connectMessage()
  // },
  // computed: {
  //   userShow() {
  //     return this.$store.state.userShow;
  //   }
  // },
  methods: {
    getUnreadMessage () {
      this.$ajax
        .post(
          '/enterprise-service/Enterprise/userMessageList',
          this.postData({
            userId: sessionStorage.userUuid,
            state: 1,
            pageNumber: 1,
            pageSize: 10
          })
        )
        .then(res => {
          if (res.code === '200') {
            this.$store.commit('unreadList', res.data.list)
            this.$store.commit('unreadMessage', res.data.totalCount)
          }
        })
    },
    getReadMessage () {
      this.$ajax
        .post(
          '/enterprise-service/Enterprise/userMessageList',
          this.postData({
            userId: sessionStorage.userUuid,
            state: 0,
            pageNumber: 1,
            pageSize: 10
          })
        )
        .then(res => {
          if (res.code === '200') {
            this.$store.commit('readList', res.data.list)
            this.$store.commit('readTotal', res.data.totalCount)
          }
        })
    },
    // connectMessage () {
    //   if ("WebSocket" in window)
    //   {
    //     alert("您的浏览器支持 WebSocket!");
    //     // 打开一个 web socket
    //     var ws = new WebSocket("ws://192.168.1.111:3016/websocket");
    //     ws.onopen = function()
    //     {
    //       // Web Socket 已连接上，使用 send() 方法发送数据
    //       ws.send("发送数据");
    //       alert("数据发送中...");
    //     };
    //     ws.onmessage = function (evt)
    //     {
    //       var received_msg = evt.data;
    //       alert("数据已接收...");
    //     };
    //     ws.onclose = function()
    //     {
    //       // 关闭 websocket
    //       alert("连接已关闭...");
    //     };
    //   }
    //   else
    //   {
    //     // 浏览器不支持 WebSocket
    //     alert("您的浏览器不支持 WebSocket!");
    //   }

    // },
    getImgSrc2(url) {
      if (url) {
        // let first = url.lastIndexOf(":");
        // let last = url.lastIndexOf('"');
        // let finalUrl = url.substring(first + 2, last);
        return this.filesDownload(url);
      } else {
        return;
      }
    },
    doTips() {
      sessionStorage.toPath = "/";
      this.$router.push("/");
    },
    exit_() {
      this.$confirm("确定要退出登录", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(() => {
        sessionStorage.clear();
        this.$store.commit("userShow", false);
        this.$router.push("/login");
      });
    },
    intoCenter() {
      this.$router.push("/trainClass/personalCenter/learnCenter/learnTrain");
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.personal-logo {
  #head {
    width: 100%;
    background: linear-gradient(to right, #1060ab , #516dd2); /* 标准的语法 */
    .logo {
      width: 1200px;
      height: 120px;
      margin: 0 auto;
    }
    .el-badge {
      vertical-align: 0;
      top: -20px;
      margin-right: 20px;
    }
    .el-badge__content {
      position: absolute;
      padding: 0;
      height: 20px;
      width: 20px;
      border-radius: 50%;
      border: none;
      background-color: #ff0000;
      left: 5px;
      top: 5px;
    }

    #logo_left {
      float: left;
      display: flex;
      height: 120px;
      padding-top: 10px;
      .left {
        height: 100%;
        img {
          width: 100px;
          height: 100px;
        }
      }
      .right {
        color: #ffffff;
        line-height: 50px;
        .system_name {
          font-size: 22px;
          span {
            font-weight: 550;
          }
        }
        .enterprise-name {
          font-size: 18px;
        }
      }
    }
    #logo_right {
      float: right;
      margin-top: 35px;
    }
    #login {
      position: absolute;
      top: 30px;
      right: 10px;
      text-align: right;
      font-size: 14px;
      a {
        color: white;
        text-decoration: none;
      }
    }
    #login .el-message-box__header {
      background-color: white;
    }
    #login .el-message-box__title {
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/findPass/findPassHead/logo.vue